import SelectPicker from "rsuite/SelectPicker";
import 'rsuite/SelectPicker/styles/index.css';
import {useEffect, useState, useRef} from "react";

/**
 *
 * @param value
 * @returns {JSX.Element}
 * @constructor
 */
export default function Prioridad({
  setFieldValue,
  values,
  edit
}){
    const [prioridades, setPrioridades] = useState([]);
    const prioridadesRef = useRef(null);

    useEffect(() => {
            const prioridadesLS = JSON.parse(localStorage.getItem("prioridades"));
            setPrioridades(prioridadesLS);
    }, []);

    function selectPrioridad(p){
        switch (p) {
            case 'MA':
                return {icon: <i className="bi bi-chevron-double-up text-danger mx-2"></i>, color: 'danger'};
            case 'A':
                return {icon: <i className="bi bi-chevron-up text-info mx-2"></i>, color: 'info'};
            case 'N':
                return {icon: <i className="bi bi-circle-fill text-warning mx-2"></i>, color: 'warning'};
            case 'B':
                return {icon: <i className="bi bi-chevron-down text-success mx-2"></i>, color: 'success'};
            case 'MB':
                return {icon: <i className="bi bi-chevron-double-down text-primary mx-2"></i>, color: 'primary'};
            default:
                return {icon: <i className="bi bi-circle-fill text-warning mx-2"></i>, color: 'warning'};
        }
    }

    const data = [];
    prioridades.forEach(p => {
        const cssP = selectPrioridad(p.valor);
        data.push({
            icon:  cssP.icon,
            name: p.descripcion,
            color: cssP.color,
            abbr: p.valor
        })
    })

   if ( data.length > 0 ) {
       return (
           <>
               <style type={'text/css'}>
                   {`
                    #prioridad{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #prioridad > .rs-stack{
                        display : block!important;
                    }
                    #prioridad-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #prioridad > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #prioridad-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #prioridad-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #prioridad-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
               </style>
               <div className={"position-relative"} ref={prioridadesRef}>
                   <SelectPicker
                       container={() => prioridadesRef.current}
                       data={data}
                       label={<div className={'labelSelect ps-2'}>Prioridad:</div>}
                       labelKey="name"
                       valueKey="abbr"
                       name={"prioridad"}
                       id={"prioridad"}
                       cleanable={false}
                       value={values}
                       onChange={(value) => setFieldValue('prioridad', value)}
                       searchable={false}
                       style={{width: "100%"}}
                       menuStyle={{width:'100%'}}
                       // menuAutoWidth={false}
                       disabled={!edit}
                       renderMenuItem={
                           /**
                            *
                            * @param label
                            * @param item
                            * @param item.color
                            * @param item.icon
                            * @returns {JSX.Element}
                            */
                               (label, item) => {
                               return (
                                   <div className={"text-" + item.color}>
                                       {item.icon} {label}
                                   </div>
                               )
                           }}
                       renderValue={
                           /**
                            *
                            * @param value
                            * @param item
                            * @param item.color
                            * @param item.icon
                            * @param item.name
                            * @returns {JSX.Element}
                            */
                               (value, item) => {
                               return (
                                   <div className={"text-" + item.color}>
                                       {item.icon} {item.name}
                                   </div>
                               );
                           }}
                   />
               </div>
           </>
       )
   }
}
